import { render, staticRenderFns } from "./EditZones.vue?vue&type=template&id=517eb458"
import script from "./EditZones.vue?vue&type=script&lang=js"
export * from "./EditZones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports